module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "vux-box"
  }, [_c('div', {
    staticClass: "sidebar-inner"
  }, [_c('svg', {
    staticStyle: {
      "width": "60px",
      "height": "60px"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "1024px",
      "height": "1024px",
      "viewBox": "0 0 1024 1024",
      "enable-background": "new 0 0 1024 1024",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "svgpath",
    attrs: {
      "data-index": "path_0",
      "fill": "#35495e",
      "d": "M512 816.64 51.2 985.6l460.8-947.2 460.8 947.2L512 816.64 512 816.64zM509.44 207.36 189.44 862.72l317.44-117.76L506.88 207.36 509.44 207.36zM509.44 207.36"
    }
  })]), _c('br'), _c('h1', {
    staticClass: "vux-title"
  }, [_vm._v("VUX")]), _c('div', [_c('a', {
    staticClass: "vux-github",
    attrs: {
      "target": "_blank",
      "href": "https://github.com/airyland/vux"
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 64 64",
      "width": "24",
      "height": "24"
    }
  }, [_c('path', {
    attrs: {
      "stroke-width": "0",
      "fill": "currentColor",
      "d": "M32 0 C14 0 0 14 0 32 0 53 19 62 22 62 24 62 24 61 24 60 L24 55 C17 57 14 53 13 50 13 50 13 49 11 47 10 46 6 44 10 44 13 44 15 48 15 48 18 52 22 51 24 50 24 48 26 46 26 46 18 45 12 42 12 31 12 27 13 24 15 22 15 22 13 18 15 13 15 13 20 13 24 17 27 15 37 15 40 17 44 13 49 13 49 13 51 20 49 22 49 22 51 24 52 27 52 31 52 42 45 45 38 46 39 47 40 49 40 52 L40 60 C40 61 40 62 42 62 45 62 64 53 64 32 64 14 50 0 32 0 Z"
    }
  })]), _c('br')]), _c('p', {
    staticClass: "vux-center vux-sub-title vux-time-ago"
  }, [_vm._v("Since "), _c('span', [_vm._v(_vm._s(_vm.days))]), _vm._v(" Days Ago")]), _c('br'), (/zh-CN/i.test(_vm.$route.path)) ? _c('p', [_vm._m(0)]) : _vm._e()]), (_vm.showAnalytics) ? _c('div', {
    staticClass: "analytics"
  }, [_c('p', {
    staticClass: "vux-center vux-sub-title vux-time-ago"
  }, [_c('span', [_vm._v(_vm._s(_vm.analytics.total_quantity_within_30m.quantity))]), _c('br'), _vm._v("▴"), _c('br')]), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.t('Online developers')) + "\n            "), (_vm.hasReady && _vm.lang === 'zh-CN') ? _c('el-popover', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-info",
    slot: "reference"
  }), _c('p', [_vm._v("该数值表示当前正在进行 VUX(Vue) 开发的唯一用户数，非文档站访问数。\n                "), _c('br'), _vm._v("数据来源于 vux-loader 发送的匿名统计，作为 webpack 配置工具仅在 development 发送统计，不对构建文件加入任何代码。")])]) : _vm._e()], 1), _c('p', {
    staticClass: "vux-center vux-sub-title vux-time-ago"
  }, [_c('span', [_vm._v(_vm._s(_vm.analytics.total_quantity_within_24h.quantity))]), _c('br'), _vm._v("▴")]), _vm._l((_vm.analytics.user_quantity_within_24h_group_by_city.list.slice(0, 8)), function(item) {
    return _c('p', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_c('span', [_vm._v(_vm._s(item.city))]), _vm._v(" " + _vm._s(item.quantity) + "\n          ")])
  }), _c('p', {
    staticClass: "vux-center vux-sub-title vux-time-ago",
    staticStyle: {
      "padding-top": "0"
    }
  }, [_vm._v("▴")]), _c('p', {
    staticClass: "vux-center",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.t('Developers in 24h')))])], 2) : _vm._e()])]), _c('div', {
    staticClass: "summary"
  }, [_c('div', {
    staticClass: "summary-inner",
    staticStyle: {
      "left": "190px"
    }
  }, [_vm._l((_vm.summary), function(chapter) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isComponentPage),
        expression: "!isComponentPage"
      }],
      staticClass: "chapter",
      attrs: {
        "data-category": _vm.currentCategory
      }
    }, [_c('p', {
      staticClass: "chapter-title"
    }, [_vm._v(_vm._s(chapter.title))]), _c('ul', {
      staticClass: "chapter-page"
    }, _vm._l((chapter.pages), function(page) {
      return _c('li', {
        staticClass: "chapter-page-item"
      }, [_c('router-link', {
        attrs: {
          "to": _vm.getPath(page.path),
          "data-current-category": _vm.currentCategory
        }
      }, [_vm._v(_vm._s(page.title))])], 1)
    }))])
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isComponentPage),
      expression: "isComponentPage"
    }],
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "chapter-title"
  }, [_vm._v(_vm._s(_vm.t('Css')))]), _c('ul', {
    staticClass: "chapter-page"
  }, [_c('li', {
    staticClass: "chapter-page-item"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + _vm.lang + "/css/1px.html")
    }
  }, [_vm._v(_vm._s(_vm.t('1px')))])], 1), _c('li', {
    staticClass: "chapter-page-item"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + _vm.lang + "/css/close.html")
    }
  }, [_vm._v(_vm._s(_vm.t('css-close-icon')))])], 1)])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isComponentPage),
      expression: "isComponentPage"
    }],
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "chapter-title"
  }, [_vm._v(_vm._s(_vm.t('Directives')))]), _c('ul', {
    staticClass: "chapter-page"
  }, [_c('li', {
    staticClass: "chapter-page-item"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + _vm.lang + "/directives/v-transfer-dom.html")
    }
  }, [_vm._v("v-transfer-dom")])], 1)])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isComponentPage),
      expression: "isComponentPage"
    }],
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "chapter-title"
  }, [_vm._v(_vm._s(_vm.t('Toolkit')))]), _c('ul', {
    staticClass: "chapter-page"
  }, _vm._l((_vm.toolRoutes[_vm.lang]), function(route) {
    return _c('li', {
      staticClass: "chapter-page-item"
    }, [_c('router-link', {
      attrs: {
        "to": route.path
      }
    }, [_vm._v(_vm._s(_vm.t(route.title)))])], 1)
  }))]), _vm._l((_vm.categoryComponents), function(group) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isComponentPage),
        expression: "isComponentPage"
      }],
      staticClass: "chapter"
    }, [_c('p', {
      staticClass: "chapter-title"
    }, [_vm._v(_vm._s(group['category_' + _vm.lang]))]), _c('ul', {
      staticClass: "chapter-page"
    }, _vm._l((group.components), function(component) {
      return _c('li', {
        staticClass: "chapter-page-item component-list-item",
        attrs: {
          "id": ("component-list-item-" + (component.name))
        }
      }, [_c('router-link', {
        attrs: {
          "to": ("/" + _vm.lang + "/components/" + (component.name) + ".html")
        }
      }, [_vm._v(_vm._s(component.name))])], 1)
    }))])
  })], 2)]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header-nav"
  }, [_c('ul', {
    staticClass: "nav-list"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    class: _vm.$route.path === ("/" + _vm.lang + "/") || _vm.$route.path === ("/" + _vm.lang) ? 'link-active' : '',
    attrs: {
      "to": ("/" + _vm.lang + "/"),
      "exact": true
    }
  }, [_vm._v(_vm._s(_vm.t('Guide')))])], 1), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    class: _vm.isComponentPage ? 'link-active' : '',
    attrs: {
      "to": ("/" + _vm.lang + "/components/actionsheet.html")
    }
  }, [_vm._v(_vm._s(_vm.t('Components')))])], 1), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    class: /changelog/.test(_vm.$route.path) ? 'link-active' : '',
    attrs: {
      "to": ("/" + _vm.lang + "/changelog/changelog.html")
    }
  }, [_vm._v(_vm._s(_vm.t('Releases')))])], 1), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    class: /donate/.test(_vm.$route.path) ? 'link-active' : '',
    attrs: {
      "to": ("/" + _vm.lang + "/contribution/donate.html")
    }
  }, [_vm._v(_vm._s(_vm.t('Donate')))])], 1), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    class: /lab/.test(_vm.$route.path) ? 'link-active' : '',
    attrs: {
      "to": ("/" + _vm.lang + "/lab/index.html")
    }
  }, [_vm._v(_vm._s(_vm.t('Lab')))])], 1), (_vm.lang === 'zh-CN' && _vm.hide) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "https://cn.vuejs.org/v2/guide/",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Vue 中文文档")]), _c('svg', {
    staticStyle: {
      "vertical-align": "middle",
      "padding-left": "5px"
    },
    attrs: {
      "viewBox": "0 0 1024 1024",
      "width": "12",
      "height": "12"
    }
  }, [_c('defs'), _c('path', {
    attrs: {
      "d": "M864 640a32 32 0 0 1 64 0v224.096A63.936 63.936 0 0 1 864.096 928H159.904A63.936 63.936 0 0 1 96 864.096V159.904C96 124.608 124.64 96 159.904 96H384a32 32 0 0 1 0 64H192.064A31.904 31.904 0 0 0 160 192.064v639.872A31.904 31.904 0 0 0 192.064 864h639.872A31.904 31.904 0 0 0 864 831.936V640z m-485.184 52.48a31.84 31.84 0 0 1-45.12-0.128 31.808 31.808 0 0 1-0.128-45.12L815.04 166.048l-176.128 0.736a31.392 31.392 0 0 1-31.584-31.744 32.32 32.32 0 0 1 31.84-32l255.232-1.056a31.36 31.36 0 0 1 31.584 31.584L924.928 388.8a32.32 32.32 0 0 1-32 31.84 31.392 31.392 0 0 1-31.712-31.584l0.736-179.392L378.816 692.48z",
      "fill": "#333333",
      "p-id": "5014"
    }
  })])])]) : _vm._e(), (_vm.lang === 'zh-CN' && _vm.hide) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "https://vuex.vuejs.org/zh-cn/",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Vuex 中文文档")]), _c('svg', {
    staticStyle: {
      "vertical-align": "middle",
      "padding-left": "5px"
    },
    attrs: {
      "viewBox": "0 0 1024 1024",
      "width": "12",
      "height": "12"
    }
  }, [_c('defs'), _c('path', {
    attrs: {
      "d": "M864 640a32 32 0 0 1 64 0v224.096A63.936 63.936 0 0 1 864.096 928H159.904A63.936 63.936 0 0 1 96 864.096V159.904C96 124.608 124.64 96 159.904 96H384a32 32 0 0 1 0 64H192.064A31.904 31.904 0 0 0 160 192.064v639.872A31.904 31.904 0 0 0 192.064 864h639.872A31.904 31.904 0 0 0 864 831.936V640z m-485.184 52.48a31.84 31.84 0 0 1-45.12-0.128 31.808 31.808 0 0 1-0.128-45.12L815.04 166.048l-176.128 0.736a31.392 31.392 0 0 1-31.584-31.744 32.32 32.32 0 0 1 31.84-32l255.232-1.056a31.36 31.36 0 0 1 31.584 31.584L924.928 388.8a32.32 32.32 0 0 1-32 31.84 31.392 31.392 0 0 1-31.712-31.584l0.736-179.392L378.816 692.48z",
      "fill": "#333333",
      "p-id": "5014"
    }
  })])])]) : _vm._e(), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hide),
      expression: "hide"
    }],
    attrs: {
      "href": "/en/"
    }
  }, [_vm._v("English")]), _c('a', {
    on: {
      "click": _vm.switchLang
    }
  }, [_vm._v(_vm._s(/zh-CN/.test(_vm.$route.path) ? 'English(working)' : '中文'))])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Github")]), _c('svg', {
    staticStyle: {
      "vertical-align": "middle",
      "padding-left": "5px"
    },
    attrs: {
      "viewBox": "0 0 1024 1024",
      "width": "12",
      "height": "12"
    }
  }, [_c('defs'), _c('path', {
    attrs: {
      "d": "M864 640a32 32 0 0 1 64 0v224.096A63.936 63.936 0 0 1 864.096 928H159.904A63.936 63.936 0 0 1 96 864.096V159.904C96 124.608 124.64 96 159.904 96H384a32 32 0 0 1 0 64H192.064A31.904 31.904 0 0 0 160 192.064v639.872A31.904 31.904 0 0 0 192.064 864h639.872A31.904 31.904 0 0 0 864 831.936V640z m-485.184 52.48a31.84 31.84 0 0 1-45.12-0.128 31.808 31.808 0 0 1-0.128-45.12L815.04 166.048l-176.128 0.736a31.392 31.392 0 0 1-31.584-31.744 32.32 32.32 0 0 1 31.84-32l255.232-1.056a31.36 31.36 0 0 1 31.584 31.584L924.928 388.8a32.32 32.32 0 0 1-32 31.84 31.392 31.392 0 0 1-31.712-31.584l0.736-179.392L378.816 692.48z",
      "fill": "#333333",
      "p-id": "5014"
    }
  })])])]), _c('li', {
    staticClass: "search-item"
  }, [_c('algolia-search', {
    attrs: {
      "placeholder": _vm.t('Search documents'),
      "lang": _vm.lang,
      "emptyText": _vm.t('No search results')
    }
  })], 1)])]), _c('div', {
    staticClass: "markdown-body"
  }, [_c('router-view'), _c('div', [(/faq\//.test(_vm.$route.path) && /\.html/.test(_vm.$route.path)) ? _c('router-link', {
    attrs: {
      "to": ("/" + _vm.lang + "/faq/")
    }
  }, [_vm._v(" << " + _vm._s(_vm.t('return FAQ')))]) : _vm._e()], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "survey",
    attrs: {
      "href": "https://wj.qq.com/s/1170299/9518/",
      "target": "_blank"
    }
  }, [_vm._v(" VUX 开发者调查 "), _c('span', {
    staticClass: "el-icon-arrow-right\n"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9e48fde0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-9e48fde0","preserveWhitespace":false}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 288
// module chunks = 630